(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-before-after"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bf-ba__frame').forEach(function(frame){
  var range = frame.querySelector('.bf-ba__range');
  if(!range) return;
  function update(){ frame.style.setProperty('--pos', range.value + '%'); }
  range.addEventListener('input', update); update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.bfInit) return; root.dataset.bfInit='1';
    var grid=root.querySelector('.bf-gallery__grid'), input=root.querySelector('.bf-gallery__input'),
        chipsEl=root.querySelector('.bf-gallery__chips'), countEl=root.querySelector('.bf-gallery__count'),
        totalEl=root.querySelector('.bf-gallery__total'), clearBtn=root.querySelector('.bf-gallery__clear'),
        emptyEl=root.querySelector('.bf-gallery__empty'), moreBtn=root.querySelector('.bf-gallery__loadmore'),
        lbtns=[].slice.call(root.querySelectorAll('.bf-gallery__lbtn'));
    var step=parseInt(root.dataset.initial,10)||24;
    var slug=function(s){return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');};
    var sized=function(u,w){return u+(u.indexOf('?')>=0?'&':'?')+'width='+w;};
    var SERVICE_MAP={ 'fleet':'/pages/fleet-vehicle-branding','commercial-signage':'/pages/commercial-signage','design-branding':'/pages/design-branding','motorsport':'/pages/motorsport-specialty' };
    var all=[], state={q:'',filter:'*',shown:step}, lbList=[];

    function matches(it){ var q=state.q.trim().toLowerCase();
      var okF=state.filter==='*'||slug(it.c)===state.filter;
      var okQ=!q||((it.p||'')+' '+(it.c||'')+' '+(it.i||'')).toLowerCase().indexOf(q)!==-1;
      return okF&&okQ; }
    function cardHTML(it,i){ var t=(it.p||'').replace(/"/g,'&quot;');
      return '<article class="bf-card" data-idx="'+i+'">'
        +'<button class="bf-card__btn" type="button" aria-label="Open '+t+'">'
        +'<div class="bf-card__media"><img class="bf-card__img" loading="lazy" src="'+sized(it.u,900)+'" alt="'+t+' — Black Flag Designs">'
        +'<div class="bf-card__pattern"></div><div class="bf-card__overlay"><span>View project →</span></div></div>'
        +'<div class="bf-card__cap"><div class="bf-card__svc">'+(it.c||'')+'</div>'
        +'<h3 class="bf-card__title">'+(it.p||'')+'</h3>'
        +(it.i?'<div class="bf-card__client">'+it.i+'</div>':'')+'</div></button></article>'; }
    function render(){ lbList=all.filter(matches); var slice=lbList.slice(0,state.shown);
      grid.innerHTML=slice.map(cardHTML).join('');
      countEl.textContent=slice.length; totalEl.textContent=lbList.length;
      emptyEl.hidden=lbList.length!==0; grid.style.display=lbList.length===0?'none':'';
      moreBtn.hidden=state.shown>=lbList.length;
      clearBtn.hidden=!(state.filter!=='*'||state.q.trim()!==''); }

    function setLayout(n){ root.dataset.layout=n; lbtns.forEach(function(b){b.classList.toggle('is-active',b.dataset.layout===n);}); }
    lbtns.forEach(function(b){ b.addEventListener('click',function(){ setLayout(b.dataset.layout); }); });
    setLayout(root.dataset.layout||'grid');
    if(input) input.addEventListener('input',function(){ state.q=input.value; state.shown=step; render(); });
    moreBtn.addEventListener('click',function(){ state.shown+=step; render(); });
    function clearAll(){ state.q=''; state.filter='*'; state.shown=step; if(input) input.value='';
      chipsEl.querySelectorAll('.bf-chip').forEach(function(c){ c.classList.toggle('is-active',c.dataset.filter==='*'); }); render(); }
    clearBtn.addEventListener('click',clearAll);
    root.querySelectorAll('.bf-gallery__reset').forEach(function(b){ b.addEventListener('click',clearAll); });

    // Lightbox
    var lb=root.querySelector('.bf-lb'), mediabox=lb.querySelector('.bf-lb__mediabox'), cur=0;
    function fill(i){ var d=lbList[i]; if(!d) return; cur=i;
      lb.querySelector('.bf-lb__svc').textContent=d.c||'';
      lb.querySelector('.bf-lb__title').textContent=d.p||'';
      lb.querySelector('.bf-lb__client').innerHTML=d.i?'Industry · <span style="color:#dcdcdc">'+d.i+'</span>':'';
      lb.querySelector('.bf-lb__blurb').textContent='';
      var svcA=lb.querySelector('.bf-lb__service'); var href=SERVICE_MAP[slug(d.c)];
      if(href){ svcA.href=href; svcA.textContent='Explore '+(d.c||'service'); svcA.hidden=false; } else { svcA.hidden=true; }
      mediabox.innerHTML=''; var img=document.createElement('img'); img.src=sized(d.u,1600); img.alt=d.p||''; mediabox.appendChild(img); }
    function open(i){ fill(i); lb.hidden=false; document.body.style.overflow='hidden'; }
    function close(){ lb.hidden=true; mediabox.innerHTML=''; document.body.style.overflow=''; }
    function stepLb(dir){ if(!lbList.length) return; cur=(cur+dir+lbList.length)%lbList.length; fill(cur); }
    grid.addEventListener('click',function(e){ var c=e.target.closest('.bf-card'); if(!c) return; open(parseInt(c.dataset.idx,10)); });
    lb.querySelector('.bf-lb__close').addEventListener('click',close);
    lb.querySelector('.bf-lb__backdrop').addEventListener('click',close);
    lb.querySelector('.bf-lb__prev').addEventListener('click',function(){ stepLb(-1); });
    lb.querySelector('.bf-lb__next').addEventListener('click',function(){ stepLb(1); });
    document.addEventListener('keydown',function(e){ if(lb.hidden) return; if(e.key==='Escape') close(); if(e.key==='ArrowRight') stepLb(1); if(e.key==='ArrowLeft') stepLb(-1); });

    fetch(root.dataset.src).then(function(r){return r.json();}).then(function(data){
      all=data||[]; if(!all.length){ emptyEl.hidden=false; return; }
      // chips from categories
      var cats={}; all.forEach(function(it){ if(it.c) cats[it.c]=(cats[it.c]||0)+1; });
      var html='<button class="bf-chip is-active" data-filter="*">All <span class="bf-chip__n">'+all.length+'</span></button>';
      Object.keys(cats).sort().forEach(function(c){ html+='<button class="bf-chip" data-filter="'+slug(c)+'">'+c+' <span class="bf-chip__n">'+cats[c]+'</span></button>'; });
      chipsEl.innerHTML=html;
      // URL deep-link ?category=
      try{ var q=new URLSearchParams(location.search).get('category'); if(q){ state.filter=slug(q); chipsEl.querySelectorAll('.bf-chip').forEach(function(c){ c.classList.toggle('is-active',c.dataset.filter===state.filter); }); } }catch(e){}
      chipsEl.addEventListener('click',function(e){ var b=e.target.closest('.bf-chip'); if(!b) return;
        chipsEl.querySelectorAll('.bf-chip').forEach(function(c){c.classList.remove('is-active');}); b.classList.add('is-active');
        state.filter=b.dataset.filter; state.shown=step; render(); });
      render();
    }).catch(function(){ emptyEl.hidden=false; });
  }
  function boot(){ document.querySelectorAll('.bf-gallery').forEach(init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-race-hq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.bfInit) return; root.dataset.bfInit = '1';
    var days = root.querySelector('.bf-racehq__nextdays');
    if(days && days.dataset.date){
      var d = Math.ceil((new Date(days.dataset.date) - new Date()) / 864e5);
      days.textContent = d > 0 ? d + ' days' : (d === 0 ? 'Race day' : '');
    }
    var chips = Array.prototype.slice.call(root.querySelectorAll('.bf-chip'));
    var posts = Array.prototype.slice.call(root.querySelectorAll('.bf-post'));
    // order newest-first by date
    var feedEl = root.querySelector('.bf-racehq__feed');
    if(feedEl){ posts.slice().sort(function(a,b){ return (b.dataset.date||'').localeCompare(a.dataset.date||''); }).forEach(function(p){ feedEl.appendChild(p); }); }
    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.toggle('is-active', c === chip); });
        var f = chip.dataset.filter;
        posts.forEach(function(p){ p.classList.toggle('is-hidden', f !== '*' && p.dataset.type !== f); });
      });
    });
  }
  function boot(){ document.querySelectorAll('.bf-racehq').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bf-tabs').forEach(function(root){
  var btns = root.querySelectorAll('.bf-tabs__btn');
  var panels = root.querySelectorAll('.bf-tabs__panel');
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var i = btn.getAttribute('data-index');
      btns.forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-index') === i); });
      panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-index') === i); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.bfd-gallery');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    const grid = root.querySelector('.bfd-gallery__grid');
    const filtersEl = root.querySelector('.bfd-gallery__filters');
    const loadBtn = root.querySelector('.bfd-gallery__loadmore');
    const viewAll = root.querySelector('.bfd-gallery__viewall');
    const countEl = root.querySelector('.bfd-gallery__count');
    const emptyEl = root.querySelector('.bfd-gallery__empty');
    const step = parseInt(root.dataset.initial, 10) || 12;
    const galleryLink = root.dataset.galleryLink || '';
    const showFilters = root.dataset.showFilters !== 'false';
    const preview = !!galleryLink; // preview mode: fixed count + CTA, no load-more
    const slug = s => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const sized = (u, w) => u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    const forcedCat = slug(root.dataset.filterCategory || '');

    let items = [], filter = forcedCat || 'all', shown = step;

    function render() {
      const list = items.filter(it => filter === 'all' || slug(it.c) === filter);
      const slice = list.slice(0, shown);
      grid.innerHTML = slice.map(it => `
        <figure class="bfd-tile" tabindex="0" role="button" aria-label="View ${(it.p||'').replace(/"/g,'')}"
          data-full="${sized(it.u, 1600)}" data-caption="${(it.p||'').replace(/"/g,'&quot;')}">
          <img class="bfd-tile__img" loading="lazy" src="${sized(it.u, 800)}" alt="${(it.p||'').replace(/"/g,'&quot;')} — Black Flag Designs">
          <figcaption class="bfd-tile__cap">
            <span class="bfd-tile__project">${it.p || ''}</span>
            ${it.c ? `<span class="bfd-tile__cat">${it.c}</span>` : ''}
          </figcaption>
        </figure>`).join('');
      if (preview) {
        countEl.textContent = '';
        loadBtn.hidden = true;
        viewAll.hidden = false;
      } else {
        countEl.textContent = 'Showing ' + slice.length + ' of ' + list.length;
        loadBtn.hidden = shown >= list.length;
      }
    }

    // Lightbox (one global)
    let lb = document.querySelector('.bfd-lightbox');
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'bfd-lightbox';
      lb.innerHTML = '<button class="bfd-lightbox__close" aria-label="Close">×</button><img alt=""><div class="bfd-lightbox__cap"></div>';
      document.body.appendChild(lb);
    }
    const lbImg = lb.querySelector('img'), lbCap = lb.querySelector('.bfd-lightbox__cap');
    const closeLb = () => { lb.classList.remove('is-open'); lbImg.src = ''; };
    grid.addEventListener('click', e => { const t = e.target.closest('.bfd-tile'); if (!t) return; lbImg.src = t.dataset.full; lbCap.textContent = t.dataset.caption || ''; lb.classList.add('is-open'); });
    grid.addEventListener('keydown', e => { const t = e.target.closest('.bfd-tile'); if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); t.click(); } });
    lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('bfd-lightbox__close')) closeLb(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLb(); });

    loadBtn.addEventListener('click', () => { shown += step; render(); });

    if (galleryLink) { viewAll.href = galleryLink; }
    fetch(root.dataset.src).then(r => r.json()).then(data => {
      items = data || [];
      if (!items.length) { emptyEl.hidden = false; return; }
      // URL deep-link (?category=fleet) preselects a filter on the full gallery
      if (!forcedCat) {
        try { const q = new URLSearchParams(location.search).get('category'); if (q) filter = slug(q); } catch (e) {}
      }
      if (showFilters && !preview && !forcedCat) {
        const cats = [...new Set(items.map(it => it.c).filter(Boolean))];
        filtersEl.innerHTML = ['All', ...cats].map((c) => {
          const fv = c === 'All' ? 'all' : slug(c);
          return `<button class="bfd-pill${fv === filter ? ' is-active' : ''}" type="button" data-filter="${fv}">${c}</button>`;
        }).join('');
        filtersEl.addEventListener('click', e => {
          const b = e.target.closest('.bfd-pill'); if (!b) return;
          filtersEl.querySelectorAll('.bfd-pill').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active'); filter = b.dataset.filter; shown = step; render();
        });
      }
      render();
    }).catch(() => { emptyEl.hidden = false; });
  })();

  } catch(e) { console.error(e); }
})();
})();
